import { useLocation } from "react-router-dom";

import { ButtonWithIcon } from "components/UI/ButtonWithIcon/ButtonWithIcon";
import IntroMarkets from "./IntroMarkets/IntroMarkets";
import HiddenContent from "components/UI/HiddenContent/HiddenContent";
import IntroIllustration from "./IntroIllustration/IntroIllustration";

import AppStore from "AppStore";

import "./Intro.scss";

const PATH_STYLE_CLASSES = {
  "prodvizhenie-trekov-yandexmusic": "circle-yandex",
  "prodvizhenie-trekov-yandexmusic-presave": "circle-yandex",
  "prodvizhenie-trekov-yandexmusic-proslushka": "circle-yandex",
  "prodvizhenie-trekov-vkmusic": "circle-vk",
  "prodvizhenie-trekov-vkmusic-presave": "circle-vk",
  "prodvizhenie-trekov-vkmusic-proslushka": "circle-vk",
  "promotion-on-spotify": "circle-spotify",
  "promotion-on-applemusic": "circle-apple",
};


export default function Intro({ title, children, marketMode, isTablet, isMobile, hiddenContent, classesReviewAvito, classesReviewYandex, shouldShowBreadcrumbs }) {
  const { pathname } = useLocation();
  const path = pathname.slice(1);
  const circleClass = PATH_STYLE_CLASSES[path] || "";
  const isMaxMessengerPage = path.includes('nakrutka-podpischikov-max');

  return (
    <div className={`intro ${shouldShowBreadcrumbs ? "other-style" : ""}`}>
      <div className="intro__info-container">
        {isMobile && circleClass && (
          <>
            <div className={`intro__container-markets_big-circle other-visible ${circleClass}`} />
            <div className="intro__container-markets_small-circle other-visible" />
          </>
        )}
        <div className="intro__info-title">
          <h1 className="intro__title">{title}</h1>
          {hiddenContent && <HiddenContent content={hiddenContent} />}
          <div>{children}</div>
        </div>
        {isTablet && (
          <>
            {classesReviewAvito || classesReviewYandex ? (
              <div className={`intro-markets__container-review ${classesReviewAvito ? 'avito' : 'yandex'}`}/>
            ) : isMaxMessengerPage ? (
              <div className="intro-markets__container-review max"/>
            ) : (
              <IntroIllustration marketMode={marketMode} shouldShowBreadcrumbs={shouldShowBreadcrumbs} />
            )}
          </>
        )}
      </div>
      <div className={`intro__container-markets ${shouldShowBreadcrumbs ? "other-style" : ""}`}>
        {!isTablet && AppStore.isMarketPage(pathname) && <IntroMarkets marketMode={marketMode} isTablet={isTablet} isMobile={isMobile} shouldShowBreadcrumbs={shouldShowBreadcrumbs} />}
        {isMobile && marketMode.bots && <ButtonWithIcon title="Скачать презентацию" ariaLabel="Скачать презентацию" to="/docs/presentation-ya-pf.pdf" target="_blank" className="button-with-icon" />}
        {!isMobile && <div className={`intro__container-markets_big-circle ${shouldShowBreadcrumbs ? `other-visible ${circleClass}` : ""}`} />}
        {!isMobile && <div className={`intro__container-markets_small-circle ${shouldShowBreadcrumbs ? "other-visible" : ""}`} />}
      </div>
      {isTablet && AppStore.isMarketPage(pathname) && <IntroMarkets marketMode={marketMode} isTablet={isTablet} isMobile={isMobile} />}
    </div>
  );
}
